<template>
  <div class="flex flex-wrap w-full max-w-xl mx-auto">
    <div class="w-full item-outer col p-3">
      <div class="border h-full flex flex-col justify-between items-center rounded item_border item_border_arrow relative border_main11">
        <div class="p-2 w-full gept_main_bg flex items-center justify-between">
          <p class="font-bold text-white md:text-lg text-center">輸入測試</p>
          <p class="font-bold text-white md:text-lg text-center">已輸入 {{ textLength }} 個單字</p>
        </div>
        <div class="p-3 px-3 mb-1 cursor-pointer w-full">
          <textarea v-model="inputVal" name="TestingTools" id="" rows="5" class="border rounded w-full p-2 border_main13" placeholder="點此輸入......"></textarea>
        </div>

        <div class="p-3">
          <p class="gept_main_color md:text-lg text-center font-semibold">請在框內輸入英文，確認設備與輸入法有正常運作。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestingTools',
  props: {
  },
  data () {
    return {
      inputVal: null
    }
  },
  computed: {
    textLength () {
      if (this.inputVal) {
        let words = this.inputVal.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "").split(" ")
        let wordCount = words.filter(word => word.length > 0).length
        return wordCount
      }
      return 0
    }
  },
  watch: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
</style>
